import * as yup from "yup";

const addressSchema = yup.object().shape({
  addressLine1: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values in address field")
    .label("Address Line 1"),
  addressLine2: yup.string().label("Address Line 2"),
  country: yup.string().required().label("Country"),
  state: yup.string().required().label("State"),
  city: yup.string().required().label("City"),
  pincode: yup
    .string()
    .required()
    .matches(/^[0-9]+$/, "Please enter a valid pincode")
    .min(6)
    .max(6)
    .label("Pincode"),
});

export default addressSchema;
